<template>
	<section class="main-content background-color contentblocks">
		<slot name="contentBlockContent" />
		<div
			v-for="(block, index) in items"
			:key="block.ID"
			class="content-block"
			:class="index % 2 === 0 ? 'block-left' : 'block-right'"
		>
			<div class="row">
				<div class="columns column6 image-block" :class="index % 2 === 0 ? 'left' : 'right'">
					<picture>
						<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
						<source :srcset="block.image" />
						<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
					</picture>
				</div>
				<div class="columns column6 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
					<h3>{{ block.header }}</h3>
					<div v-parse-links v-html="block.content" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.content-block {
	margin: 50px auto;
	position: relative;

	.row {
		position: relative;
		z-index: 2;
		padding: 30px 20px 0 30px;

		&::before {
			content: '';
			display: block;
			position: absolute;
			inset: 0 30% 30px 20px;
			background: #131313;
			z-index: 1;
		}
	}

	&.block-right {
		.row {
			padding: 30px 30px 0 20px;

			&::before {
				inset: 0 20px 30px 30%;
			}
		}
	}

	.columns {
		padding: 0;
	}

	.image-block {
		position: absolute;
		right: 50px;
		bottom: 0;
		top: 30px;
		width: 50%;
		z-index: 3;

		&.left {
			right: auto;
			left: 50px;
		}

		img {
			object-fit: cover;
			width: 100%;
			height: 100%;
		}
	}

	.contentblock-content {
		padding: 95px 75px;
		background: #fff;
		z-index: 4;
		min-height: 460px;
	}
}

@media (max-width: 900px) {
	.content-block {
		.image-block,
		.image-block.left {
			position: relative;
			width: 100%;
			inset: auto;
		}

		img {
			width: 100%;
			height: auto;
		}

		.contentblock-content {
			padding: 40px;
		}
	}

	.row {
		padding: 30px 10px 30px 30px !important;

		&::before {
			inset: 10px 15% 60px 10px !important;
		}
	}
}
</style>
